import {
  createWebHashHistory,
  createWebHistory,
  createRouter,
  RouteRecordRaw,
} from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/20231109/Index.vue"),
  },
  {
    path: "/:anchor",
    name: "IndexAnchor",
    component: () => import("@/views/20231109/Index.vue"),
  },
];

export default createRouter({
  // history: createWebHashHistory(),
  // routes,
  history: createWebHistory(import.meta.env.VITE_BASE),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // if (to.query.q) {
    //   return {};
    // } else {
    //   console.log("gotop");
    //   return { left: 0, top: 0 };
    // }
  },
});
